import React, { useState } from "react";

interface NewsletterNameStepProps {
  suggestedName: string;
  onConfirm: (name: string) => void;
  isLoading: boolean;
}

const NewsletterNameStep: React.FC<NewsletterNameStepProps> = ({
  suggestedName,
  onConfirm,
  isLoading,
}) => {
  const [name, setName] = useState(suggestedName);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onConfirm(name.trim());
    }
  };

  return (
    <div style={{ textAlign: "center", maxWidth: "480px", width: "100%" }}>
      <h2 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>
        Name your newsletter
      </h2>
      <p style={{ color: "#666", marginBottom: "1.5rem", fontSize: "0.9rem" }}>
        We came up with a suggestion, but feel free to change it.
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          style={{
            width: "100%",
            padding: "14px 18px",
            fontSize: "1.2rem",
            fontWeight: 600,
            border: "2px solid #e0e0e0",
            borderRadius: "12px",
            outline: "none",
            marginBottom: "1.5rem",
            boxSizing: "border-box",
            textAlign: "center",
          }}
        />
        <button
          type="submit"
          disabled={!name.trim() || isLoading}
          className="secondary-button"
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "0.95rem",
            whiteSpace: "nowrap", maxWidth: "none",
            opacity: !name.trim() || isLoading ? 0.5 : 1,
          }}
        >
          {isLoading ? "Continuing..." : "Confirm Name →"}
        </button>
      </form>
    </div>
  );
};

export default NewsletterNameStep;
